import React from 'react';
import {ScaleTime} from 'd3-scale';
import {axisBottom} from 'd3-axis';
import {select} from 'd3-selection';
import moment from 'moment';

interface SimpleBottomAxisProps {
  scale: ScaleTime<number, number>;
  marginBottom: number;
  chartHeight: number;
  secondPeriodStart: Date;
  extraTicks?: Date[];
}

export default class SimpleBottomAxis extends React.Component<SimpleBottomAxisProps> {
  private readonly axisElement: React.RefObject<SVGGElement>;

  constructor(props: SimpleBottomAxisProps) {
    super(props);
    this.axisElement = React.createRef();
  }

  componentDidMount() {
    this.renderAxis();
  }

  componentDidUpdate() {
    this.renderAxis();
  }

  renderAxis() {
    const {scale, secondPeriodStart, extraTicks = []} = this.props;

    const axis = axisBottom(scale)
      .tickValues([scale.domain()[0], secondPeriodStart, ...extraTicks, scale.domain()[1]])
      .tickFormat(t => moment(t as Date).format('MM/DD'));
    if (!this.axisElement.current) return null;

    select(this.axisElement.current).call(axis);
  }

  render() {
    const {chartHeight, marginBottom} = this.props;

    return <g ref={this.axisElement} transform={`translate(0, ${chartHeight - marginBottom})`} />;
  }
}
